/**
 * 问题聚类管理
 */
import i18n from "@/i18n";

// 聚类卡片列表客户端数据转换
function clusterCards2Client(result) {
    let ret = {
        totalCards: result.count,
        cardsList: []
    };

    result.list.forEach(function(item) {
        ret.cardsList.push({
            clusterId: item.cluster_id,
            clusterKeywords: item.cluster_keywords,
            questionCount: item.question_count,
            questionList: cvtQuestionContent(item.question_list, item.cluster_id)
        });
    });
    return ret;
}

// 每一个聚类里问题列表转换
function cvtQuestionContent(contents, clusterId) {
    let ret = [];

    contents.forEach(function(content) {
        ret.push({
            clusterId: clusterId,
            questionId: content.question_id,
            questionText: content.question_text,
            isYester: content.is_yester_question,
            checked: false
        });
    });

    return ret;
}

// 常规闭环客户端数据格式
function conventional2Client(result) {
    const channelObj = {
        all: i18n.t("zhiji.overview.allChannel"),
        sdk: i18n.t("zhiji.channel.SDKSet"),
        sdk_login: i18n.t("zhiji.channel.SDKLogin"),
        m_guest: i18n.t("zhiji.channel.m_guest"),
        m_setting: i18n.t("zhiji.channel.m_setting"),
        h5_block: i18n.t("zhiji.channel.H5Scenes"),
        h5_safety: i18n.t("zhiji.channel.H5Site")
    };
    let tableData =
        result &&
        result.list.map(item => {
            return {
                question: item.content,
                questionTime: item.question_time,
                channel: channelObj[item.channel_original],
                rowId: item.auto_id,
                addData: {
                    rowId: item.auto_id,
                    question: item.content
                }
            };
        });
    return {
        tableData,
        totals: result.count || "0"
    };
}

// 聚类日志详情客户端数据格式
function logDetail2Client(result) {
    let briefData = [
        {
            key: i18n.t("zhiji.cluster.logDetail.deleted"),
            value: result.delete_count
        },
        {
            key: i18n.t("zhiji.cluster.logDetail.related"),
            value: result.insert_ext_question_count
        },
        {
            key: i18n.t("zhiji.cluster.logDetail.created"),
            value: result.insert_question_count
        }
    ];

    const labels = {
        "2": i18n.t("zhiji.cluster.logDetail.deleted"),
        "3": i18n.t("zhiji.cluster.logDetail.created"),
        "4": i18n.t("zhiji.cluster.logDetail.related")
    };

    let tableData = result.list.map(data => {
        return {
            time: data.create_time,
            result: data.mark_question,
            question: data.question_text,
            operator: data.operator,
            addData: {
                status: labels[data.status]
            }
        };
    });

    return {
        total: result.count,
        currentCount: result.count,
        briefData,
        tableData
    };
}

// 获取常规数据闭环参数
function conventionalListParams(reqData) {
    return {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        size: reqData.size,
        page: reqData.page,
        channel: reqData.channel || "all",
        field: reqData.search,
        lang: reqData.lang
    };
}

export default {
    clusterCards2Client,
    conventional2Client,
    logDetail2Client,
    conventionalListParams
};
